import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../environments/environment';

interface PromptData {
    id: number;
    prompt_key: string;
    label: string;
    cached_context_prompt: string;
    user_prompt: string;
    description: string;
    version: number; // 追加
    updated_at: string;
}

@Component({
    selector: 'app-prompts',
    templateUrl: './prompts.component.html',
    styleUrls: ['./prompts.component.scss']
})
export class PromptsComponent implements OnInit {
    targetKey = 'credit_risk_standard_v1';

    promptData: PromptData | null = null;
    loading = false;
    saving = false;

    constructor(
        private http: HttpClient,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit(): void {
        this.loadPrompt();
    }

    loadPrompt(): void {
        this.loading = true;
        this.http.get<PromptData>(`${environment.apiUrl}/prompts/${this.targetKey}`)
            .subscribe({
                next: (data) => {
                    this.promptData = data;
                    this.loading = false;
                },
                error: (err) => {
                    console.error('Failed to load prompt', err);
                    this.snackBar.open('プロンプトの読み込みに失敗しました', 'Close', { duration: 3000 });
                    this.loading = false;
                }
            });
    }

    savePrompt(): void {
        if (!this.promptData) return;

        this.saving = true;
        const payload = {
            cached_context_prompt: this.promptData.cached_context_prompt,
            user_prompt: this.promptData.user_prompt,
            label: this.promptData.label,
            description: this.promptData.description
        };

        this.http.post<PromptData>(`${environment.apiUrl}/prompts/${this.targetKey}`, payload)
            .subscribe({
                next: (data) => {
                    this.promptData = data;
                    this.saving = false;
                    this.snackBar.open('プロンプトを保存しました', 'Close', { duration: 3000 });
                },
                error: (err) => {
                    console.error('Failed to save prompt', err);
                    this.snackBar.open('保存に失敗しました', 'Close', { duration: 3000 });
                    this.saving = false;
                }
            });
    }
}